import { Icon } from '@advanza/ui'
import { ReactNode } from 'react'
import style from './label.module.css'

interface Props {
    text: ReactNode
    bgColor?: string
    icon?: string
    color?: string
}

const Label = ({ text, bgColor, icon, color }: Props) => {
    return (
        <div
            style={{
                backgroundColor: bgColor,
                color,
            }}
            className={style.label}>
            {icon && <Icon style={{ color }} name={icon} fontSize={17} />} {text}
        </div>
    )
}

export default Label
